import "./Guide.css";
import Stage from "../stage/Stage";

function Exp() {
  return (
    <Stage>
      <h1>Twinking % Add. Xp</h1>
      <p className="guideText">
        Once you've reached TL4, you may notice that the leveling begins to dry
        up. This guide seeks to provide the means of buffing your % Add. Xp stat
        to reduce your time bashing rocks. Without a Bureaucrat or Advy, you'll
        be looking at 30-50% if you can wrangle a set of % Add. Xp gear. The
        maximum possible % Add. Xp stat is pushing 80-90% with all the OSBs and
        XP pistols.
      </p>
      <p className="guideText">
        There is an{" "}
        <a
          href="https://www.ao-universe.com/guides/classic-ao/gameplay-guides-6/xp-boosters-4"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          AO-Universe guide
        </a>{" "}
        for buffing % Add. Xp, but it is for the wrong patch version and doesn't
        include PRK specific items.
      </p>
      <h1>Perk line: Training Seminar</h1>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=212190&patch=15000100"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Training Seminar +1-7%
        </a>
      </h1>
      <p className="guideText">General experience boost perk line.</p>
      <h1>Nano line: Experience boost</h1>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=90444&patch=15000100"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Baton of Command +9/6/3%
        </a>
      </h1>
      <p className="guideText">Bureaucrat experience boost nano line.</p>
      <h1>Nano line: 550</h1>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=223620"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Directorship +1-10%
        </a>
      </h1>
      <p className="guideText">
        Bureaucrat experience boost perk line. It is an aura applied to
        teammates.
      </p>
      <h1>Perk line: Commanding Presence</h1>
      <h1>
        <a
          href="https://prk.tinkeringidiot.com/items/210929"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Commanding Presence 10 +2%
        </a>
      </h1>
      <p className="guideText">
        Bureaucrat AAO/AAD aura that gains an xp buff at perk 10, or level 205.
      </p>
      <h1>Nano line: Shadowlands Maps</h1>
      <h1>
        <a
          href="https://prk.tinkeringidiot.com/items/227514"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Knowledge of The End +5%
        </a>
      </h1>
      <p className="guideText">
        Adventurer experience boost nano. This nano is rollable.
      </p>
      <h1>Weapons</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=124428"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          MTI B-94 +1-10%
        </a>
      </h1>
      <p className="guideText">
        Rollable pistol. Can be dual wielded. Damage is very low however.
      </p>
      <h1>
        <a
          href="https://prk.tinkeringidiot.com/items/500107"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Perfected Immortal Katana +4%
        </a>
      </h1>
      <p className="guideText">
        Melee energy two-hander that drops from Commander Jocasta in Cyborg
        Barracks. PRK only.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=245680&patch=15040000"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          JAME Blaster Prototype +1-2%
        </a>
      </h1>
      <p className="guideText">AR that Drops from dryad dynas in Adonis.</p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=246421"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Perennium Beamer/Blaster/Sniper +1-4%
        </a>
      </h1>
      <p className="guideText">
        Powerful crafted guns that are profession locked to Fixer/Soldier/Agent.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=245223"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Dark Pistol +1-3%
        </a>
      </h1>
      <p className="guideText">
        Crypt of Home pistol. Bureaucrat and left hand only.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=160272"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Kaen-Archibald Kolt +1-6%
        </a>
      </h1>
      <p className="guideText">
        Rollable pistol. Advy only. Can be dual wielded.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=165140"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Nophex Plasma Destroyer II +2%
        </a>
      </h1>
      <p className="guideText">Drops from Notum Soldier. Soldier only.</p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=165140"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Reet-Tech Junior Urban Crossbow II +1-2%
        </a>
      </h1>
      <p className="guideText">Rollable/common pool rifle-bow.</p>{" "}
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=274979"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Reflex/Twitch Pistol +1-2%
        </a>
      </h1>
      <p className="guideText">
        Adventurer only pistol from Milky Way prisoners. Requires 2000/2100
        pistol.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=205736"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Briefcase of Holding +1%
        </a>
      </h1>
      <p className="guideText">Tradeskilled Bureaucrat psych weapon.</p>
      <p className="guideText">
        The lowest stage tinker pistol to buff % Add. Xp is not obtainable
        (Hollow Island) as of writing.
      </p>
      <h1>Neck</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=262954&patch=18040500"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Sided Token Boards 1-8%
        </a>
      </h1>
      <p className="guideText">Obtained when signing a faction application.</p>
      <h1>Finger</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=84145&patch=18040400"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          IQ Ring 1-14%
        </a>
      </h1>
      <p className="guideText">
        Drops in mission chest loot, Cyborgs, and Drills.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=226287&patch=15000100"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Shadowlands Progression Rings (Sanguine Ring for the Artillery Unit)
          1-5%
        </a>
      </h1>
      <p className="guideText">
        Given by Ergo to enter the next Shadowlands zone. Right finger only.
      </p>
      <h1>Back</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=274702"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Complete Prisoner Cloaks (Cloak of the Reanimated Gladiator (5/5)) 3%
        </a>
      </h1>
      <p className="guideText">
        Tradeskilled from Crypt of Home and Escaped Prisoner loot.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=281468"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Cultist Outfit 3%
        </a>
      </h1>
      <p className="guideText">Dark Ruins solo reward.</p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=160708&patch=14020100"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Spirit Shroud of the Support Unit 1%
        </a>
      </h1>
      <p className="guideText">Drops from Notum Scourges in Penumbra.</p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=206136&patch=17070000"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Charred Abaddon Chassis 2%
        </a>
      </h1>
      <p className="guideText">
        Inner Sanctum 2nd floor boss loot. Soldier only.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=160708&patch=14020100"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Standard Bureaucrat Suit 1-3%
        </a>
      </h1>
      <p className="guideText">
        Drops from dynas and chest loot. Bureaucrat only.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=156538&patch=17060000"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Universal Office Worker Suit 1%
        </a>
      </h1>
      <p className="guideText">
        Bureaucrat only suit from{" "}
        <a
          href="https://www.ao-universe.com/guides/classic-ao/tradeskill-guides-6/armor-5/bureaucrat-suit"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Foremans.
        </a>
      </p>
      <h1>Feet</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=218947"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Support Unit Crepuscule Boots 1%
        </a>
      </h1>
      <p className="guideText">
        Tradeskilled Shadowlands armor. Must be QL 151 or higher.
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=218947"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Faithful/Chosen Bureaucrat Boots 1-3%
        </a>
      </h1>
      <p className="guideText">Bureaucrat Tier 3 armor. Sided only.</p>
      <h1>Shoulder</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=269897"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Shoulderpads of the Icy Wastes 1-2%
        </a>
      </h1>
      <p className="guideText">
        Unique Alappaa boss loot. Can be upgraded to equip 1 on each shoulder.
      </p>
      <h1>Chest</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=246314&patch=17060000"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Predator Armor Vest 1%
        </a>
      </h1>
      <p className="guideText">Drops from predator dynas in Elysium.</p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=245510&patch=15030000"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Omni Special Issue Grey Jacket 1%
        </a>
      </h1>
      <p className="guideText">Omni startup quest reward.</p>
      <h1>Arms</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=165361&patch=16000000"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Unbecoming Sleeves of Ljotur 1%
        </a>
      </h1>
      <p className="guideText">Drops from Ljotur world boss.</p>
      <h1>Head</h1>
      <hr />
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=246311&patch=15050000"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Spirit Ring of Self-Education 1-3%
        </a>
      </h1>
      <p className="guideText">Drops from Hiathlin dynas in Elysium.</p>
      <h1>Implants</h1>
      <hr />
      <p className="guideText">
        % Add. Xp clusters can be found in Jobe Market. The vendor is closeby
        the portal from Jobe Platform. They require psychology to craft. Numbers
        in parenthesis are refined implants (201+).
      </p>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=172215&ql=151"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Ear Implant 5-7(8)%
        </a>
      </h1>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=194431&ql=110"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Feet Implant 3-4(5)%
        </a>
      </h1>
      <h1>
        <a
          href="https://auno.org/ao/db.php?id=192796&ql=110"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          Leg Implant 2-3%
        </a>
      </h1>
    </Stage>
  );
}

export default Exp;
